import FrameworkScorecard from "@/components/FrameworkScorecard";
import { STANDARDS } from "@/constants/testIds";
import { Users } from "lucide-react";

export default function LeafScorecard({ periodId }) {
  return (
    <FrameworkScorecard
      periodId={periodId}
      base="leaf"
      t={STANDARDS.leaf}
      readinessLabel="LEAF readiness"
      bonusIcon={Users}
      pdfName={`roots-nparks-leaf-${periodId}.pdf`}
      caveat={<>A readiness aid — <b>not a certification or an NParks award</b>. It covers only the landscape-management portion a contractor can evidence; the NParks physical site audit and new-build design scoring are out of scope.</>}
    />
  );
}
